import { createSlice } from '@reduxjs/toolkit'

export const pageSizeSlice = createSlice({
  name: 'pageSize',
  initialState: {
    replenishmentsList: "25",
    replenishmentProductsList: "100",
    warehousesList: "25",
    ordersList: "25",
    processingOrdersList: "25",
    shippedOrdersList: "25",
    returnsList: "25",
    locationsList: "15",
    inventoryHistoryList: "25",
    claimsList: "25",
    operatorsList: "25",
    storesList: "25",
    workOrdersList: "25",
    bulkReturnsList: "25",
    deletedLostHistoryList: "20",
    shippingPackagesList: "25",
    lastmileShippingMethodsList: "25",
    dispatchSchedulesList: "25",
    automatedCoverageDeactivationsList: "25",
    cycleCountsList: "25",
    foundStockList: "25"
  },
  reducers: {
    setReplenishmentsListPageSize: (state, action) => {
        state.replenishmentsList = action.payload
    },
    setReplenishmentsProductsListPageSize: (state, action) => {
      state.replenishmentProductsList = action.payload
    },
    setWarehousesListPageSize: (state, action) => {
        state.warehousesList = action.payload
    },
    setOrdersListPageSize: (state, action) => {
        state.ordersList = action.payload
    },
    setBillingConfigStoresListPageSize: (state, action) => {
        state.storesList = action.payload
    },
    setProcessingOrdersListPageSize: (state, action) => {
        state.processingOrdersList = action.payload
    },
    setShippedOrdersListPageSize: (state, action) => {
        state.shippedOrdersList = action.payload
    },
    setReturnsListPageSize: (state, action) => {
        state.returnsList = action.payload
    },
    setLocationsListPageSize: (state, action) => {
        state.locationsList = action.payload
    },
    setInventoryHistoryListPageSize: (state, action) => {
        state.inventoryHistoryList = action.payload
    },
    setClaimsPageSize: (state, action) => {
        state.claimsList = action.payload
    },
    setOperatorsPageSize: (state, action) => {
      state.operatorsList = action.payload
    },
    setWorkOrdersPageSize: (state, action) => {
        state.workOrdersList = action.payload
    },
    setBulkReturnsListPageSize: (state, action) => {
        state.bulkReturnsList = action.payload
    },
    setDeletedLostHistoryPageSize: (state, action) => {
        state.deletedLostHistoryList = action.payload
    },
    setShippingPackagesPageSize: (state, action) => {
        state.shippingPackagesList = action.payload
    },
    setLastmileShippingMethodsPageSize: (state, action) => {
        state.lastmileShippingMethodsList = action.payload
    },
    setDispatchSchedulesPageSize: (state, action) => {
        state.dispatchSchedulesList = action.payload
    },
    setAutomatedCoverageDeactivationsPageSize: (state, action) => {
        state.automatedCoverageDeactivationsList = action.payload
    },
    setCycleCountsPageSize: (state, action) => {
        state.cycleCountsList = action.payload
    },
    setFoundStockPageSize: (state, action) => {
        state.foundStockList = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setReplenishmentsListPageSize,
  setReplenishmentsProductsListPageSize,
  setWarehousesListPageSize,
  setOrdersListPageSize,
  setProcessingOrdersListPageSize,
  setShippedOrdersListPageSize,
  setReturnsListPageSize,
  setLocationsListPageSize,
  setInventoryHistoryListPageSize,
  setClaimsPageSize,
  setOperatorsPageSize,
  setBillingConfigStoresListPageSize,
  setWorkOrdersPageSize,
  setBulkReturnsListPageSize,
  setDeletedLostHistoryPageSize,
  setShippingPackagesPageSize,
  setLastmileShippingMethodsPageSize,
  setDispatchSchedulesPageSize,
  setAutomatedCoverageDeactivationsPageSize,
  setCycleCountsPageSize,
  setFoundStockPageSize
 } = pageSizeSlice.actions

export default pageSizeSlice.reducer
